/*@ngInject*/
export default ['$resource', 'BASE_URL', function ($resource, BASE_URL) { return $resource(BASE_URL + "/msisdns/buy"); }];
//# sourceMappingURL=emails.sender.pricing.service.js.map